import React, { ReactNode } from 'react';
import { useI18n } from 'app/components/localization';
import Modal from 'app/components/modals/Modal';
import ModalContent from 'app/components/modals/ModalContent';
import ModalFooter from 'app/components/modals/ModalFooter';
import ModalFooterButton from 'app/components/modals/ModalFooterButton';
import AlertBox, { AlertVariant } from 'app/components/presentation/alert/AlertBox';
import { useClasses } from 'app/utils/css';

interface IProps {
  onClose: () => void;
  children: ReactNode;
  variant: AlertVariant;
}

export default function Message({ onClose, children, variant }: IProps) {
  const { t } = useI18n();
  const classes = useClasses({
    content: {
      width: '600px',
      maxWidth: '100vw',
    },
  });

  return (
    <Modal onClose={onClose}>
      <div data-testid="message-modal" className={classes.content}>
        <ModalContent>
          {/* Since this is rendered inside of a dialog box and is the primary content, there is no need */}
          {/* to give this an alert role. */}
          <AlertBox variant={variant}>
            {children}
          </AlertBox>
        </ModalContent>

        <ModalFooter>
          <ModalFooterButton onClick={onClose}>
            {t('admin.modals.confirm.confirm')}
          </ModalFooterButton>
        </ModalFooter>
      </div>
    </Modal>
  );
}
